import { Fragment } from 'react';

import gasPump from '~/assets/icons/gas-pump.svg';
import speedIcon from '~/assets/icons/speed.svg';
import trunkIcon from '~/assets/icons/trunk.svg';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { setVehicleSpecsExpanded } from '../../redux/slices/menuPanelsSlice';
// import { CircularArrowButton } from '../CircularArrowButton';
import { numWord } from '~/shared';
import { ExpandWindow } from '../ExpandWindow';
import { VehicleProperty } from '../VehicleProperty';
import {
	StyledStatsHeader,
	StyledVehiclePropertyContainer,
	StyledVehicleTag,
} from './VehicleSpecs.styled';

const VehicleSpecs = (props: React.HtmlHTMLAttributes<HTMLDivElement>) => {
	const vehicleShopVehicles =
		useObservable(rage.vehicleShop.getShopInfo())?.vehicles || [];
	const selectedIndex = useLayoutSelector(
		(state) => state.vehicleSelection.selectedIndex,
	);
	const currentVehicle = vehicleShopVehicles[selectedIndex];
	const expanded = useLayoutSelector(
		(state) => state.menuPanels.expanded.vehicleSpecs,
	);
	const dispatch = useLayoutDispatch();

	return (
		<ExpandWindow
			title={'Информация о транспорте'}
			height={320}
			expanded={expanded}
			toggleExpand={() => dispatch(setVehicleSpecsExpanded(!expanded))}
			{...props}
		>
			{currentVehicle && (
				<Fragment>
					<StyledStatsHeader>
						<Text style={{ fontSize: 20, fontWeight: 500, color: '#ffffff' }}>
							{currentVehicle.name}
						</Text>
						{currentVehicle?.tags?.discount && (
							<StyledVehicleTag
								type="discount"
								discount={currentVehicle?.tags?.discount}
							/>
						)}
					</StyledStatsHeader>
					<StyledVehiclePropertyContainer>
						<VehicleProperty
							name="Макс. скорость"
							measure="км/ч"
							value={currentVehicle.specs.maxSpeed}
							icon={speedIcon}
						/>
						<VehicleProperty
							name="Бак"
							measure="л."
							value={currentVehicle.specs.fuelTankCapacity}
							icon={gasPump}
						/>
						<VehicleProperty
							name="Багажник"
							measure={numWord(currentVehicle.specs.trunkVolume, [
								'слот',
								'слота',
								'слотов',
							])}
							value={currentVehicle.specs.trunkVolume}
							icon={trunkIcon} // todo: Smaller version of trunk icon?
						/>
					</StyledVehiclePropertyContainer>
					{/* todo: Add packs */}
					{/* {selectedPack !== -1 && <StatsContent>
					<StyledTag>Комплектация</StyledTag>
					<StyledPackSelectionContainer>
						<CircularStatsButton direction={'left'} onClick={} />
						<StyledMenuSection text={vehicle.packs[selectedPack]} />
						<CircularStatsButton direction={'right'} onClick={} />
					</PackSelectionContainer>
				</StatsContent>} */}
				</Fragment>
			)}
		</ExpandWindow>
	);
};

export { VehicleSpecs };
